/* @flow */

export default class UniversignTransaction {
  id: string;
  isSigned: boolean;
  mobile: string;
  url: string;
}
